import {
  LkNotificationPage as Data,
  LkNotificationPageCollection as Collection,
} from '@/typings/api/NotificationPage'

import { BaseLkApiAuth } from '@/api/BaseApiAuth'
import { AxiosRequestConfig } from 'axios'


export class LkNotificationsPagesApi extends BaseLkApiAuth<Data, Collection> {
  protected readonly endpoint = 'pages';

  public getByUrl(
    uri: Data['url'],
    params: Record<string, unknown> = {},
    config: AxiosRequestConfig = {},
  ) {
    const path = ''
    const [url] = this.getUrl(path, params)
    return this.request<never, never>('GET', url, {
      params: {
        ...params,
        url: uri,
      },
      ...config,
    })
  }
}
